// extracted by mini-css-extract-plugin
export default {"container":"RevenueTab_container__ZW93C","header":"RevenueTab_header__Xh0ez","error":"RevenueTab_error__pM7m2"};